import {Button, Col, Form, Input, message, Modal, Row, Select, Space} from "antd";
import {OPERATING_INSTRUCTIONS} from "../../../util/Constants";
import {useEffect, useState} from "react";
import {useForm} from "antd/es/form/Form";
import {JointAccountTemplateDto} from "../../../dto/JointAccountTemplateDto";
import accountService from "../../../service/accountService";
import ErrorHandler from "../../../util/ErrorHandler";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import TextArea from "antd/es/input/TextArea";
import {
    MSG_JOINT_ACCOUNT_TEMPLATE_CREATED_SUCCESSFULLY,
    MSG_JOINT_ACCOUNT_TEMPLATE_CREATION_FAILURE_ERROR
} from "../../../util/Messages";
import {getLoggedUserCinNumber} from "../../../security/KeyclockConfig";
import customerService from "../../../service/customerService";


const JointAccountTemplateRequest = () => {
        const [isModalOpen, setModalOpen] = useState(false);
        const [jointAccountTemplateList, setJointAccountTemplateList] = useState<JointAccountTemplateDto[]>([]);
        const [accountNumberList, setAccountNumberList] = useState<DropdownListDto[]>([]);
        const [reference, setReference] = useState<string>("");
        let [form] = useForm();
        const [cinNumber, setCinNumber] = useState<string | null>();


        useEffect(() => {
            getLoggedUserCIN()

        }, []);

        const getLoggedUserCIN = () => {
            let cinNumber = getLoggedUserCinNumber();
            if (undefined != cinNumber) {
                setCinNumber(cinNumber)
                getJointAccountTemplates(cinNumber);
            }else {
                customerService.getCustomerCINByLoggedUser().then(res => {
                    let cinNumber = res.data.results;
                    setCinNumber(cinNumber)
                    getJointAccountTemplates(cinNumber);
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                })
            }

        }

        const onSubmit = (values: any) => {
            if (cinNumber) {
                setModalOpen(false)
                let jointAccountTemplateDto: JointAccountTemplateDto = {
                    cin: cinNumber,
                    reference: reference,
                    operatingInstructions: values.operatingInstructions,
                    accountId: values.defaultBankAccountNumber
                }
                accountService.saveJointAccountTemplate(jointAccountTemplateDto).then(res => {
                    if (res.data.results) {
                        message.success(MSG_JOINT_ACCOUNT_TEMPLATE_CREATED_SUCCESSFULLY)
                        const updatedList = jointAccountTemplateList.slice(1);
                        if (updatedList.length > 0) {
                            getAccountNumbers(updatedList[0].reference)
                            form.resetFields(['defaultBankAccountNumber', 'operatingInstructions'])
                        }
                        setJointAccountTemplateList(updatedList);
                    } else {
                        message.error(MSG_JOINT_ACCOUNT_TEMPLATE_CREATION_FAILURE_ERROR)
                    }
                    setModalOpen(true)
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                })
            }
        }

        const getJointAccountTemplates = (cinNumber: string) => {
            if (null != cinNumber) {
                accountService.checkAndRequestJointAccountTemplateRequest(cinNumber).then(res => {
                    setJointAccountTemplateList(res.data.results)
                    if (res.data.results.length >= 1) {
                        setModalOpen(true)
                        let reference = res.data.results[0].reference;
                        getAccountNumbers(reference)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                })
            } else {
                console.error("Unable to find cin number.");
            }
        }

        const getAccountNumbers = (reference: string|undefined) => {
            if (undefined != reference) {
                setReference(reference)
                accountService.getJointAccountHoldersBankAccounts(reference).then(res => {
                    setAccountNumberList(res.data.results);
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                })
            }
        }


        return (
            <>
                {jointAccountTemplateList.length > 0 ?
                    <Modal title="Joint Account Template"
                           open={isModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           footer={null}
                           closable={false}
                           className={'dashboard-account-open-modal'}>
                        <Form
                            className='form-input attachments-upload-form'
                            layout={"vertical"}
                            form={form}
                            onFinish={onSubmit}
                        >
                            <h4>Please fill the joint account template in order to finalize the creation of the joint account.</h4>
                            <Form.Item
                                label="Secondary Joint Account Holder"
                            >
                                <Input disabled defaultValue={jointAccountTemplateList[0].name}/>
                            </Form.Item>
                            <Form.Item
                                name={"defaultBankAccountNumber"}
                                label="Default Bank Account"
                                initialValue={jointAccountTemplateList[0].accountId}
                                rules={[{
                                    required: true,
                                    message: 'Please select bank account'
                                }]}>
                                <Select placeholder={"Select bank account"}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        options={accountNumberList}
                                        defaultValue={jointAccountTemplateList[0].accountId}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"operatingInstructions"}
                                label="Operating Instructions"
                                initialValue={jointAccountTemplateList[0].operatingInstructions}
                                rules={[{
                                    required: true,
                                    message: 'Please select operating instructions'
                                }]}>
                                <Select placeholder={"Select operating instructions"}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        defaultValue={jointAccountTemplateList[0].operatingInstructions}
                                        options={
                                            [
                                                {
                                                    value: OPERATING_INSTRUCTIONS.PRIMARY_PARTY_VALUE,
                                                    label: OPERATING_INSTRUCTIONS.PRIMARY_PARTY_LABEL
                                                },
                                                {
                                                    value: OPERATING_INSTRUCTIONS.SECONDARY_PARTY_VALUE,
                                                    label: OPERATING_INSTRUCTIONS.SECONDARY_PARTY_LABEL
                                                },
                                                {
                                                    value: OPERATING_INSTRUCTIONS.EITHER_PARTIES_VALUE,
                                                    label: OPERATING_INSTRUCTIONS.EITHER_PARTIES_LABEL
                                                },
                                                {
                                                    value: OPERATING_INSTRUCTIONS.BOTH_PARTIES_VALUE,
                                                    label: OPERATING_INSTRUCTIONS.BOTH_PARTIES_LABEL
                                                }
                                            ]
                                        }
                                />
                            </Form.Item>
                            {jointAccountTemplateList[0].rejectReason ?
                            <Form.Item
                                label="Secondary Holder Rejected Reason">
                                <TextArea showCount maxLength={255}
                                          bordered={true}
                                          disabled
                                          defaultValue={jointAccountTemplateList[0].rejectReason}/>
                            </Form.Item>: <></>}
                            <Row className='modal-btn-row'>
                                <Col span={24}>
                                    <Space style={{float: 'right'}}>
                                        <Button htmlType="submit"
                                                type="primary">
                                            Submit
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>

                    </Modal> : <></>}
            </>
        );
    }
;

export default JointAccountTemplateRequest;
